

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/miinteressa">AREE TEMATICHE</a></span></li>
            <li class="last"><span><a href="/sirang/acque">ACQUE</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout" id="aui_3_4_0_1_591">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_H7pGyMq5rlnM_">
                     <span id="p_56_INSTANCE_H7pGyMq5rlnM"></span> 
                     <div class="portlet-body" id="aui_3_4_0_1_590">
                        <section class="portlet" id="portlet_56_INSTANCE_H7pGyMq5rlnM">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Acque interne, sotterranee e marino costiere</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content" id="aui_3_4_0_1_589">
                              <div class=" portlet-content-container" style="" id="aui_3_4_0_1_588">
                                 <div class="portlet-body" id="aui_3_4_0_1_587">
                                    <div class="journal-content-article" id="aui_3_4_0_1_586">
                                       <div class="rer-contextual-text" id="aui_3_4_0_1_585">
                                          <p> Il modulo dedicato all'area tematica delle<strong> Acque interne, sotterranee e marino costiere</strong> contiene al suo interno oggetti che sono notevolmente differenti tra loro per origine, per caratteristiche tecniche e per normativa di riferimento. La loro gestione ha lo scopo di supportare l'attività e le esigenze informative degli enti preposti al controllo dell'uso sostenibile e della qualità delle risorse idriche regionali.</p>
                                          <p> I moduli applicativi che vengono realizzati nel SIRA per quest'area tematica hanno come principale finalità quella di rispondere alle molteplici le esigenze informative e gestionali degli Enti preposti alla pianificazione e gestione della tematica, in particolare della Direzione generale Agenzia regionale del distretto idrografico della Sardegna, dei Servizi Regionali, delle Province, di ARPAS e dei Comuni.</p>
                                          <p> Tale area è costituita da macrocomponenti affini per settore ambientale di appartenenza, ma differenti soprattutto per ciò che concerne le caratteristiche intrinseche e gli aspetti tecnico-procedurali di pertinenza. In considerazione della complessità e della vastità dell'argomento, si rende necessaria la progettazione e la realizzazione di molteplici moduli e sezioni applicative, che di seguito vengono sintetizzati:</p>
                                          <ul>
                                             <li> <strong>Bacini e corpi idrici </strong>comprendente i catasti relativi ai diversi oggetti idrografici gestiti (es. bacini idrografici, corsi d'acqua, laghi e invasi ecc.)</li>
                                             <li> <strong>Qualità delle acque:</strong> i catasti relativi a impianti di depurazione, scarichi, piezometri, frantoi, siti di spandimento reflui oleari, fognature, aziende che utilizzano fertilizzanti azotati, siti di spandimento di fertilizzanti azotati, aziende che utilizzano fanghi di depurazione in agricoltura, siti di spandimento fanghi,</li>
                                             <li> <strong>Utilizzazione della risorsa idrica</strong>: i catasti relativi a Pozzi, sorgenti captazioni idriche, fontanili, utenze acqua pubblica, opere acquedottistiche, sbarramenti, dighe, laghetti collinari</li>
                                          </ul>
                                       </div>
                                       <p> Il modulo gestisce inoltre le informazioni relative alle comunicazioni per l'utilizzazione in agricoltura delle sanse umide e acque di vegetazione, che vengono inserite via web nel sistema direttamente dal titolare del frantoio.</p>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
            <div class="aui-w30 portlet-column" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_RxuFFVEU5ofT_">
                     <span id="p_56_INSTANCE_RxuFFVEU5ofT"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_RxuFFVEU5ofT">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Dati ambientali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <a target="_blank" href="https://portal.sardegnasira.it/web/sardegnaambiente/dati-ambientali-acqua">Vai alla pagina</a></li>
<!--
                                          <li> <a href="https://www.regione.sardegna.it/autoritadibacino/" target="_blank">Autorità di bacino</a></li>
                                          <li> <a href="http://www.regione.sardegna.it/autoritadibacino/organizzazione/direzionegeneraleagenziaregionaledeldistrettoidrograficodellaSardegna/" target="_blank">Agenzia di Distretto idrografico della Regione Sardegna (ADIS)</a></li>
                                          <li> <a href="http://www.sardegnaambiente.it/argomenti/acqueinterneecostiere/" target="_blank">Regione Sardegna </a></li>
                                          <li> <a href="http://www.sardegnaambiente.it/arpas/arpas/" target="_blank">ARPA Sardegna e relativi dipartimenti provinciali</a></li>
                                          <li> <a href="http://www.provincia.cagliari.it/ProvinciaCa/it/ambiente.page;jsessionid=0E16E8346981582F211B35A593ED46CC" target="_blank">Pubbliche amministrazioni locali regionali</a></li>
                                          <li> <a href="http://www.aslcagliari.it/" target="_blank">ASL</a></li>
                                          <li> <a href="https://www.abbanoa.it/" target="_blank">Abbanoa</a></li>
   
-->                                          
                                       </ul>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
                  <!--
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_tnHHpmmM5e8T_">
                     <span id="p_56_INSTANCE_tnHHpmmM5e8T"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_tnHHpmmM5e8T">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Temi</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <u><span style=""><em><strong>Bacini e corpi idrici </strong></em></span></u></li>
                                          <li> <u><span style=""><em><strong>Qualità delle acque</strong></em></span></u></li>
                                          <li> <u><span style=""><em><strong>Utilizzazione della risorsa idrica</strong></em></span></u></li>
                                       </ul>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
                  -->
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>